import { render } from "./PhotoCardsHeader.vue?vue&type=template&id=45a6bbb4"
import script from "./PhotoCardsHeader.vue?vue&type=script&lang=js"
export * from "./PhotoCardsHeader.vue?vue&type=script&lang=js"

import "./PhotoCardsHeader.vue?vue&type=style&index=0&id=45a6bbb4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__